import { idb } from '@/modules/util/idb'

export class Cache {
    store
	settings = { 
		expiry: 1000 * 60 * 60 * 24 * 2,
	}

	keyPath
	keyGen

	constructor(store, settings={}, keyPath=undefined, keyGen=undefined) {
		if (keyPath === 'timestamp' || keyPath === 'value') {
			throw new Error(`Reserved field: '${keyPath}' cannot be used as keyPath`)
		}

    	this.store = store
		this.settings = { 
			...this.settings, 
			...settings,
		}
		
		this.keyPath = keyPath
		this.keyGen = keyGen
	}

	async get(key) {
    	const data = await idb.get(this.store, key)

		if (!data) {
			return null
		}

		if (this.settings.expiry) {
			if (data.timestamp + this.settings.expiry < new Date().getTime()) {
				idb.remove(this.store, key)
				return null
			}
		}

		return data
	}

	async all() {
		await this.clean()
    	return await idb.list(this.store)
	}

	async keys() {
		await this.clean()
		return await idb.keys(this.store)
	}

	async set(value, key=undefined) {
		const data = {
			timestamp: new Date().getTime(),
			value: value,
		}

		if (this.keyPath) {
			if (!key) {
				if (!this.keyGen) {
					throw new Error('Key is required, no key generator provided')	
				}

				key = this.keyGen(value)
			}

			data[this.keyPath] = key
		}

    	await idb.upsert(this.store, data)
		return key
	}

	async remove(key) {
    	return await idb.remove(this.store, key)
	}

	async clean() {
		if (this.settings.expiry) {
			await idb.each(this.store, (cursor) => {
				if (cursor.value.timestamp + this.settings.expiry < new Date().getTime()) {
					cursor.delete()
				}
			})
		}
	}

	static async clearAll() {
		return await idb.clearAll()
	}
}

